import axios from 'axios';
import {environment} from 'environment';
import qs from 'qs';

/**
 * Axios instance for all `analysis` api requests.
 *
 * An `axios` instance utilising `axios-cache-adapter` and `localforage` for
 * caching responses to localStorage.
 */
const analysisApi = axios.create({
  baseURL: `${environment.endpoint('analysis')}/analysis/api`,
  paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
});

export default analysisApi;
